export default __webpack_public_path__ + "static/media/2.d459de06.svg";